import React,{ useState, useEffect }  from 'react';
import { Product, Times,Dates } from '../ProductCard/ProductCard';
import { API_ENDPOINTS } from '../../config/apiConfig';
import { time } from 'console';
type EventItem = {
  id: number;
  title: string;
  startDate: string; // ISO yyyy-mm-dd
  endDate?: string; // optional end date for ranges
  time?: string;
  description: string[];
  location?: string;
  places?: number;
};

const formatDate = (d: Date) =>
  d.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });

const EventsList: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
  
    useEffect(() => {
      const fetchProducts = async () => {
        try {
          const response = await fetch(API_ENDPOINTS.EVENTS);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const productsData = await response.json();
          setProducts(productsData);
        } catch (err) {
          setError('Failed to fetch products');
          console.error('Error fetching products:', err);
        } finally {
          setLoading(false);
        }
      };
  
      fetchProducts();
    }, []);
  
    if (loading) {
      return <div>Loading products...</div>;
    }
  
    if (error) {
      return <div>Error: {error}</div>;
    }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const events = (products as Product[])
    .map((e): EventItem => ({
      id: e.id,
      title: e.name,
      startDate: e.dates?.[0]?.dateStart ?? "",
      endDate: e.dates?.[0]?.dateEnd ?? "",
      time: e.times?.[0]?.from ?? "",
      description: e.description,
      places: e.places ?? 0,
    }))
    .map((e) => ({
      ...e,
      start: new Date(e.startDate),
      end: e.endDate ? new Date(e.endDate) : new Date(e.startDate),
    }))
    .filter((e) => {
      const end = new Date(e.end);
      end.setHours(0, 0, 0, 0);
      return end >= today; // keep if the range hasn't finished
    })
    .sort((a, b) => a.start.getTime() - b.start.getTime());

  if (events.length === 0) {
    return (
      <div className="container">
        <p>Aucun événement à venir.</p>
      </div>
    );
  }

  return (
    <div className="container events-list">
      {events.map((e) => (
        <div key={e.id} className="card event-card">
          <h3>{e.title}</h3>
          <div className="event-meta">
            <time>
              {e.start.getTime() === e.end.getTime()
                ? formatDate(e.start)
                : `Du ${formatDate(e.start)} au ${formatDate(e.end)}`}
              {e.time && e.start.getTime() === e.end.getTime() ? ` — ${e.time}` : ''}
            </time>
            {e.location && <span className="event-location"> — {e.location}</span>}
          </div>
          {e.description != null ? <p>{e.description.join(', ')}</p> : ''}
        </div>
      ))}
    </div>
  );
};

export default EventsList;
